<template>
  <div class="page-index print-index">
    <div class="printer-box">
      <ul>
        <li>批次号：{{batchNumer}}</li>
        <li>数量：{{num}}</li>
        <!-- <li>已打印数量：{{printedNum}}</li> -->
        <li v-if="printStatus === 0">打印状态：未开始打印</li>
        <li v-if="printStatus === 1">打印状态：打印任务传输中</li>
        <li v-if="printStatus === 2">打印状态：正在打印中</li>
        <li v-if="printStatus === 3">打印状态：打印完成</li>
        <li>
          <span>选择打印机：</span>
          <el-select class="search-input2" @change="setDefaultPrinter" v-model="printer" placeholder="请选择打印机">
            <el-option v-for="item in printers" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li v-show="false">
          <span>任务大小：</span>
          <el-input class="input" v-model="takeNum" type="number" :disabled="checked"></el-input>
          <el-checkbox v-model="checked">默认设置</el-checkbox>
          <div style="color:red;font-size:16px;">*注：一次任务最多50张，最少10张</div>
        </li>
        <li>
          <div style="color:red;font-size:16px;font-weight:bold;">*注：打印过程中请勿关闭此窗口！</div>
        </li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="printStatus === 0 || printStatus === 3" type="primary" @click="handlePrint">打印</el-button>
      <el-button v-if="printStatus === 1 || printStatus === 2" type="info">打印</el-button>
    </span>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { formatDate } from '../../utils/common'
  import { apiList, apiAdd, apiUpdateStatus, apiDetail, jcpExit } from '../../api/labelPrint'
  import { getJCP } from '../../../public/jcp'
  import DDDY from '../../../public/dddy'

  export default {
    mixins: [tableMixin],
    name: 'print',
    data() {
      return {
        key: '', // 获取token用
        labelPrintId: '', // 批次id
        batchNumer: '', // 批次号
        num: '', // 打印数量
        number: '', // 模板
        printers: [], // 打印机列表
        printer: '', // 默认打印机
        printStatus: 0, // 打印状态
        list: [], // 批次数据列表
        checked: true, // 是否选中
        timer: 0, // 计时器
        takeNum: 10 // 任务数量
      }
    },
    created() {
      this.key = (localStorage.getItem('companyCode') || '').toLowerCase() + '_' + (localStorage.getItem('account') || '')
      this.takeNum = localStorage.getItem('takeNum') || 10
      this.printStatus = Number(this.$route.query.printStatus || 0)
      this.labelPrintId = this.$route.query.labelPrintId
      this.number = this.$route.query.number
      this.getPrinters()
      this.getData(_ => {
        if (this.printStatus === 2) {
          window.onbeforeunload = function(event) {
            event.returnValue = 1
          }
          this.handlePrint()
        }
      })
    },
    activated() {},
    methods: {
      handleClose() {},
      /**
       * jcp进程守护
       */
      jcpWatch() {
        this.timer = setTimeout(_ => {
          jcpExit().then(_ => {
            this.jcp_timeout()
          }).catch(_ => {
            this.jcp_timeout()
          })
        }, 3 * 60 * 1000)
      },
      jcp_timeout() {
        setTimeout(_ => {
          window.opener.open('jatools://fuck')
        }, 1000)
        setTimeout(_ => {
          // window.location.href = `/print/index?labelPrintId=${this.labelPrintId}&number=${this.number}&printStatus=2`
          window.opener.open(`/print/index?labelPrintId=${this.labelPrintId}&number=${this.number}&printStatus=2`, `printer${new Date().getTime()}`, 'height=310, width=453, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no')
          window.opener = null
          window.onbeforeunload = null
          window.close()
        }, 2000)
      },
      /**
       * 获取打印机列表
       */
      getPrinters() {
        console.log('获取打印机')
        getJCP().getPrinters(printers => { // 打印机列表
          this.printers = printers
          console.log(printers)
        })
        getJCP().getDefaultPrinter(printer => { // 默认打印机
          this.printer = printer
          console.log(printer)
        })
      },
      /**
       * 设置默认打印机
       */
      setDefaultPrinter() {
        getJCP().setDefaultPrinter(this.printer, () => {
          getJCP().getDefaultPrinter(result => {
            console.log(result)
          })
        })
      },
      /**
       * 获取打印任务
       */
      getData(callback = null) {
        apiList(this.labelPrintId).then(data => {
          if (data.data.length === 0) {
            this.$alert('该批次已经打印完成。', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.opener = null
                window.onbeforeunload = null
                window.close()
              }
            })
          } else {
            this.batchNumer = data.data[0].batchNumer
            this.num = data.data.length
            this.list = data.data
            if (typeof callback === 'function') {
              callback()
            }
          }
        })
      },
      /**
       * 打印
       */
      handlePrint() {
        if (this.printStatus === 3) {
          this.$message({
            type: 'warning',
            message: '打印已完成'
          })
          return
        }
        if (this.takeNum > 50 || this.takeNum < 10) {
          this.$message({
            type: 'warning',
            message: '打印任务最多50张，最少10张'
          })
          return
        }
        localStorage.setItem('takeNum', this.takeNum)
        if (this.num <= 0) {
          this.$message({
            type: 'warning',
            message: '没有可打印的标签'
          })
          return
        }
        this.printStatus = 1
        this.jcpWatch()
        this.jcpPrint(this.list)
      },
      jcpPrint(data) {
        window.onbeforeunload = function(event) {
          event.returnValue = 1
        }
        let that = this
        let length = data.length
        if (length <= 0) return
        let arr = [...data].splice(0, this.takeNum)
        let dataset = JSON.stringify(that.dataFormart(arr)) // 10张
        DDDY.getToken(that.key, function(result) {
          if (result.token) {
            DDDY.print(result.token, that.number, dataset, false, function(res) {
              if (res) {
                that.$message({
                  type: 'warning',
                  message: res.error_message
                })
                that.printStatus = 0
              } else {
                that.printStatus = 2
                that.apiUpdateStatus(that, data)
              }
            })
          }
        })
      },
      /**
       * 打印状态更新
       */
      apiUpdateStatus(that, data) {
        clearTimeout(that.timer)
        that.jcpWatch()
        apiUpdateStatus(that.labelPrintId, that.takeNum).then(() => {
          data.splice(0, that.takeNum)
          if (data.length > 0) {
            // console.log('长度:' + data.length)
            that.jcpPrint(data)
          } else {
            // console.log('长度为零打印完成' + data.length)
            clearTimeout(that.timer)
            that.printStatus = 3
            that.$alert('该批次已经打印完成。', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.opener = null
                window.onbeforeunload = null
                window.close()
              }
            })
          }
        }).catch(_ => {
          this.$message({
            type: 'warning',
            message: '网络异常或服务器异常，将在10秒后重连'
          })
          setTimeout(() => {
            that.apiUpdateStatus(that, data)
          }, 10 * 1000)
        })
      },
      /**
       * 数据格式化
       */
      dataFormart(data) {
        let dataset = []
        data.forEach(item => {
          let obj = {
            '唯一码': item.detailNumber,
            '条形码': item.batchNumer,
            '模板logo': item.logoUrlPath,
            '产品名称': item.productName,
            '产品标准编号': '产品标准编号：' + item.standardNumber,
            '生产日期': '生产日期：' + item.productDate,
            '净含量': '净含量：' + item.netWeight,
            '保质期': '保质期为' + item.period,
            '二维码': item.numberUrl,
            '畜牧局二维码': item.url,
            '合格证': 'http://dddy.sen-chang.cn/tms-resources/01.png',
            '公司名称': '生产者名称: ' + item.companyName,
            '生产许可证': '饲料生产许可证编号: ' + item.companyLicense,
            '公司生产地址': '生产地址：' + item.companyAddress,
            '公司注册地址': '注册地址：' + item.companyRegisterAddress,
            '公司邮政编码': '邮编：' + item.companyPostCode,
            '公司联系方式': '电话/传真：' + item.companyContactNumber + '/' + item.companyTel,
            '委托方公司名称': '委托企业：' + item.entrustCompanyName,
            '委托方许可证号': item.entrustCompanyLicense,
            '委托方公司生产地址': '委托方生产地址：' + item.entrustCompanyAddress,
            '委托方公司注册地址': '委托方注册地址：' + item.entrustCompanyRegisterAddress,
            '委托方公司联系方式': '电话：' + item.entrustCompanyContactNumber,
            '委托方公司邮政编码': '邮编：' + item.entrustCompanyPostCode
          }
          dataset.push(obj)
        })
        return dataset
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.print-index
    .printer-box
      ul
        list-style-type none
      li
        font-size 18px
        margin-top 20px
      .input
        display inline-block
        margin-right 20px
        width 100px
    .dialog-footer
      display block
      text-align right
      padding 0 40px
</style>
